<ng-container *ngIf="selectedProduct!=null">
        <div class="product-header-wrapper">
          <!-- Top row: avatar, name + badge, dates, strategy title + link -->
          <div class="product-header-main">
            <!-- Left block: avatar + name/status -->
            <div class="product-id-block">
              <div class="product-avatar">
                {{ computeInitials(selectedProduct) }}
                <!-- e.g. "PB" -->
              </div>
              <div class="product-meta">
                <div class="product-title-status">
                  <span class="product-title">{{ selectedProduct}}</span>
                  <span
                    class="product-badge"
                    [ngClass]="{
                      'status-approved': productMeta?.status === 'active__v',
                      'status-preapproved':
                        productMeta?.status === 'Pre‑Approved',
                      'status-withdrawn': productMeta?.status === 'Withdrawn',
                      'status-terminated': productMeta?.status === 'Terminated',
                      'status-divested': productMeta?.status === 'Divested',
                      'status-investigational':
                        productMeta?.status === 'Investigational'
                    }"
                    >{{ productMeta?.status }}</span
                  >
                </div>
                <div class="product-dates">
                  <span class="product-date-label">DIBD:</span>
                  <span class="product-date-value">{{
                    productMeta?.dibd
                  }}</span>
                  <span class="date-separator">|</span>
                  <span class="product-date-label">IBD:</span>
                  <span class="product-date-value">{{ productMeta?.ibd }}</span>
                </div>
              </div>
            </div>

            <!-- Right block: safety strategy title + link -->
            <div class="product-strategy-block">
              <h3 class="strategy-title">{{ productMeta?.safetyTitle }}</h3>
              
                <!-- [href]="productMeta?.safetyStrategyLink" -->
              <a
                class="strategy-link"
                target="_blank"
                (click)="openSafetyStrategy()"
              >
                <mat-icon aria-label="Open Link" >open_in_new</mat-icon>
              </a>
            </div>
          </div>
        </div>
      </ng-container>
